export enum DeployEnvironment {
    Production = 'production',
    Stage = 'stage',
    Develop = 'develop',
    Local = 'local'
  }
